import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

/**
 * Take the brand splash down once the app is actually on screen (see #oy-splash in index.html).
 *
 * In `finally`, not `then`: if bootstrap throws, leaving the splash up would hide the failure behind a
 * red screen with no way past it. index.html also has an 8s backstop for the case where this file
 * never runs at all — a chunk that 404s after a deploy, say.
 */
const hideSplash = () => (window as unknown as { __hideSplash?: () => void }).__hideSplash?.();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err))
  .finally(hideSplash);

/**
 * Register the app service worker. Browsers will not offer "install" for a site without one, so this
 * is what makes the Install button appear at all; the offline shell fallback is a bonus.
 *
 * Registered at scope "/" — the Firebase messaging worker registers itself separately (and lazily,
 * once the shopper allows notifications) at /firebase-cloud-messaging-push-scope. Two scopes, two
 * workers, no conflict.
 *
 * Deliberately after bootstrap and on `load`, so it never competes with the app's first paint, and
 * failures are swallowed: an unsupported browser, an insecure origin or a blocked registration must
 * leave the app working exactly as it did before.
 */
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
      /* unsupported, insecure origin, or blocked — the app works exactly as before */
    });
  });
}
